module.exports = __webpack_public_path__ + "media/images/podcast_addict-c7569981190351f3d94cb88d72a4e2dc.png";